import { Directive, HostBinding, HostListener, inject } from '@angular/core';

import { ModalSwipeDirective } from './modal-swipe.directive';

@Directive({
  selector: '[appOverlaySwipe]',
})
export class OverlaySwipeDirective {
  private modalSwipe = inject(ModalSwipeDirective);

  @HostBinding('style.opacity') opacity: string;
  @HostBinding('style.transition') transition: string;

  @HostListener('click', ['$event']) onClick(): void {
    this.fadeOverlay();
    this.modalSwipe.bottomSwipeSheet.swipeModal();
  }

  setOpacity(opacityValue: number): void {
    this.opacity = opacityValue.toString();
  }

  fadeOverlay(): void {
    this.transition = '.3s ease opacity';
    this.opacity = '0';
  }
}
